<ui-page [fullHeight]="true">
	<div [uiColSpan]="12" *ngIf="mortgages?.length > 0">
		<div class="flex flex-row justify-between align-baseline items-start">
			<ui-content-header
				title="{{
					fileType === fileTypes.SALE ? 'VTB Mortgage ' : 'Mortgages'
				}}"
				type="page"
			>
				<ui-button
					title-action
					(click)="addMortgage()"
					label="Add"
					icon="plus"
					preset="MEDIUM_EMPHASIS"
					*ngIf="fileType != fileTypes.SALE && canAdd"
				/>
			</ui-content-header>
			<ul class="flex w-full justify-end">
				<li *ngFor="let tab of tabs" class="flex -ml-6">
					<app-anchor
						[tooltip]="tab.description"
						[url]="tab.url"
						type="tab"
						[cssClasses]="['pr-10']"
					>
						<div class="space-x-3 flex flex-row align-middle items-center">
							<div class="h-4" *ngIf="tab?.logoUrl">
								<img
									class="h-full w-full"
									[src]="'/assets/images/banks/' + tab?.logoUrl"
								/>
							</div>
							<span>{{ tab.description }}</span>
						</div>
					</app-anchor>
					<app-button
						*ngIf="deletingTab !== tab.id"
						iconClasses="text-green"
						[holdable]="true"
						size="small"
						btn="tertiary"
						[icon]="ICON.REMOVE"
						class="-left-6"
						(onClick)="remove(tab)"
					></app-button>
					<app-icon [icon]="" *ngIf="deletingTab === tab.id"></app-icon>
				</li>
			</ul>
		</div>

		<router-outlet class="hidden-router"></router-outlet>
	</div>

	<div
		[uiColSpan]="12"
		*ngIf="mortgages?.length === 0"
		class="flex flex-col flex-1 justify-center items-center h-full"
	>
		<div class="empty-state-image">
			<img src="assets/images/empty-states/mortgages.svg" />
		</div>
		<h3 class="mt-10">Add mortgage instructions</h3>
		<p class="mt-3">Add mortgage instructions to your matter</p>
		<div class="mt-5">
			<app-button [icon]="ICON.ADD" size="small" (click)="addMortgage()"
				>Add mortgage</app-button
			>
		</div>
	</div>
</ui-page>
